import { render, staticRenderFns } from "./ChatEditor.vue?vue&type=template&id=825dba22&scoped=true&"
import script from "./ChatEditor.vue?vue&type=script&lang=js&"
export * from "./ChatEditor.vue?vue&type=script&lang=js&"
import style0 from "./ChatEditor.vue?vue&type=style&index=0&id=825dba22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825dba22",
  null
  
)

export default component.exports